import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { materialModules } from 'src/shared/material.module';
import { DeletedApplicantComponent } from './deleted-applicant/deleted-applicant.component';
import { PageNotFoundComponent } from './page-not-found.component';
import { UnauthorizedComponent } from './unauthorized.component';

@NgModule({
  imports: [
    materialModules,
    RouterModule,
  ],
  declarations: [
    PageNotFoundComponent,
    UnauthorizedComponent,
    DeletedApplicantComponent,
  ],
})
export class ErrorPagesRoutingModule { }
